module.exports = __webpack_public_path__ + "img/icon_like@2x.a5c1a0ab.png";